export default __webpack_public_path__ + "static/media/06.d1cb941c.webp";